<template>
  <div class="rounded bg-gray-1 px-4 py-2">
    <div class="row">
      <div class="col-12 col-md-3 d-flex">
        <div
          class="d-flex align-items-center bg-green rounded-circle my-4-custom mr-3"
        >
          <i class="fas fa-dollar-sign text-white fa-lg py-2 px-3" />
        </div>

        <div class="mt-3">
          <span class="data-label">Monto Total a Pagar:</span>
          <p class="text-green fs-22 font-weight-bold">
            ${{ totalAmount | money }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-3 d-flex">
        <div class="d-flex align-items-center my-4 mr-3">
          <i class="fas fa-file-invoice-dollar text-gray-7 fs-40" />
        </div>

        <div class="mt-3">
          <span class="data-label">Conteo de Solicitudes:</span>
          <p class="text-gray-7 fs-22 font-weight-bold">{{ count | count }}</p>
        </div>
      </div>
      <div class="col-12 col-md d-flex justify-content-end">
        <div class="d-flex align-items-center">
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger mr-3"
            @click="cancel"
          >
            Cancelar
          </action-button>
          <action-button
            i="fas fa-arrow-circle-right"
            variant="success"
            @click="processPayment"
          >
            Procesar Pago
          </action-button>
        </div>
      </div>
    </div>
    <div
      v-if="!showBillPaymentForm"
      class="col-12 bg-white rounded p-4 d-flex align-items-center justify-content-center"
    >
      <action-button
        id="btn-insert-row-number"
        class="border w-40 btn"
        i="fas fa-file-plus color-primary-1"
        text="Presione aquí para añadir cifra"
        @click="openNewDigitForm"
      />
    </div>
    <validation-observer
      v-if="showBillPaymentForm"
      ref="billPaymentForm"
      novalidate
      tag="form"
    >
      <div class="bg-white p-2">
        <div
          v-for="(digit, index) in purchaseOrderNumber"
          :key="`payment_list_${index}`"
          class="bg-gray-1 rounded py-3 mb-3 px-3"
        >
          <div class="row">
            <div class="col-md-4 mt-1">
              <div class="color-secondary-6 font-14">
                Número de Cifra:
              </div>
              <div class="color-black font-16">
                {{ digit.fullNumber }}
              </div>
            </div>
            <div class="col-sm col-md-2 mt-1">
              <div class="color-secondary-6 font-14">
                Número de línea:
              </div>
              <div class="color-black font-16">
                {{ digit.lineNumber }}
              </div>
            </div>
            <div class="col-sm col-md-2 mt-1">
              <div class="color-secondary-6 font-14">
                Tipo de Cifra:
              </div>
              <div class="color-black font-16">
                {{ digit.digitType }}
              </div>
            </div>
            <div class="col-sm col-md-2 mt-3 mt-md-1 mt-sm-3">
              <div class="color-secondary-6 font-14">
                Monto:
              </div>
              <div class="color-black font-16 font-14">
                {{ digit.amount | price }}
              </div>
            </div>
            <div class="col-sm col-md-2 mt-1 d-flex justify-content-end">
              <action-button
                id="btn-remove-digit"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger m-2 pr-4"
                @click="deleteDigit(digit)"
              >
                Eliminar
              </action-button>
            </div>
          </div>
        </div>
        <div class="row bg-white mt-3 rounded p-2 mx-1">
          <div class="col-md-4">
            <div class="color-secondary-4 font-14">
              Número de Cifra:
            </div>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.purchaseOrderNumber"
                class="w-75"
                :clearable="false"
                custom-error-msg="Favor seleccionar al menos una cifra de cuenta."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="paymentDigitList"
                placeholder="Seleccione"
                @input="onPurchaseOrderChange"
              />
            </validation-provider>
          </div>
          <div class="col-sm mt-1 pl-5">
            <div class="color-secondary-6 font-14">
              Número de lí­nea:
            </div>
            <div class="color-black font-16">
              {{ model.lineNumber }}
            </div>
          </div>
          <div class="col-sm mt-1 pl-5">
            <div class="color-secondary-6 font-14">
              Tipo de Cifra:
            </div>
            <div class="color-black font-16">
              {{ model.digitType }}
            </div>
          </div>
          <div class="col-sm mt-3 mr-4 mt-md-1 mt-sm-3">
            <div class="color-secondary-6 font-14">
              Monto:
            </div>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El monto es requerido.',
                greaterThanZero: 'El monto debe ser mayor de 0.',
              }"
              rules="required|greaterThanZero"
            >
              <div class="input-group mb-3">
                <custom-input
                  :key="purchaseOrderNumber.length"
                  v-model="model.amount"
                  class="custom-input__extended w-100"
                  :custom-error-msg="'La cantidad debe ser mayor a 0.'"
                  :error="errors[0]"
                  mask-type="Money"
                  prepend-icon="fa fa-dollar-sign"
                  :prepend-icon-left="true"
                  prepend-icon-type="success"
                />
              </div>
            </validation-provider>
          </div>
          <div
            class="col-md-2 mt-1 d-flex align-items-center justify-content-end"
          >
            <action-button
              i="fas fa-file-plus"
              variant="success m-2 pl-4 pr-4"
              @click="addBilling()"
            >
              Añadir Cifra
            </action-button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import {
  getDigitNumbers as _getDigitNumbers,
  processBulkPayment as _processBulkPayment,
} from '@/modules/reinbursement/api.js';
import alert from 'utils/mixins/alert.mixin';

export default {
  name: 'PaymentProcess',
  components: { ActionButton, CustomDropDown, CustomInput },
  filters: {
    count(value) {
      return `${value}`.length > 1 ? value : `0${value}`;
    },
    money(value) {
      if (!value) return '0.00';
      return value.toLocaleString('en-US', { minimumFractionDigits: 2 });
    },
  },
  mixins: [alert],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    year: {
      type: Number,
      default: 0,
    },
    month: {
      type: Number,
      default: 0,
    },
    academicYearId: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    digitNumbers: [],
    showBillPaymentForm: false,
    purchaseOrderNumber: [],
    model: {
      purchaseOrderNumber: null,
      amount: null,
      lineNumber: null,
      digitType: null,
    },
  }),
  computed: {
    count() {
      return this.items.length;
    },
    totalAmount() {
      if (!this.count) return 0;
      return this.items
        .map((x) => x.amountToRefund)
        .reduce((total, amount) => total + amount);
    },
    totalAmountDigits() {
      if (!this.count) return 0;
      return this.items
        .map((x) => x.amountToRefund)
        .reduce((total, amount) => total + amount);
    },
    paymentDigitList() {
      return this.digitNumbers.filter(
        (f) =>
          !this.purchaseOrderNumber.some(
            (s) =>
              s.lineNumber == f.lineNumber &&
              s.purchaseOrderNumberId == f.purchaseOrderNumberId
          )
      );
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    onPurchaseOrderChange(value) {
      this.model.lineNumber = value.lineNumber;
      this.model.digitType = value.digitType;
    },
    async addBilling() {
      let isValid = await this.$refs.billPaymentForm.validate();
      if (!isValid) {
        this.ShowToast('', 'Debe completar los campos requeridos.', 'error');
        return;
      }

      const subtotal = this.purchaseOrderNumber.reduce(
        (total, item) => total + item.amount,
        0
      );

      if (this.model.amount + subtotal > this.totalAmount) {
        this.ShowToast(
          '',
          'La cantidad sobrepasa el monto de la solicitud.',
          'error'
        );
        return;
      }

      if (this.model.amount <= 0) {
        this.ShowToast('', 'El monto debe ser mayor que 0.', 'error');
        return;
      }

      const item = {
        digitType: this.model.digitType,
        lineNumber: this.model.lineNumber,
        purchaseOrderNumberId: this.model.purchaseOrderNumber
          .purchaseOrderNumberId,
        fullNumber: this.model.purchaseOrderNumber.name,
        amount: this.model.amount,
      };
      this.purchaseOrderNumber.push(item);
      this.clearForm();
    },
    clearForm() {
      this.model.purchaseOrderNumber = null;
      this.model.lineNumber = null;
      this.model.digitType = null;
      this.model.amount = null;
      this.$refs.billPaymentForm.reset();
    },
    deleteDigit(item) {
      const i = this.purchaseOrderNumber.findIndex(
        (x) => x.purchaseOrderNumberId == item.purchaseOrderNumber
      );

      this.purchaseOrderNumber.splice(i, 1);
    },
    async openNewDigitForm() {
      this.showBillPaymentForm = true;
      await _getDigitNumbers(this.year).then((data) => {
        let response = data.data;
        this.digitNumbers = response.sort((a, b) =>
          a.lineNumber > b.lineNumber ? 1 : b.lineNumber > a.lineNumber ? -1 : 0
        );
      });
    },
    async processPayment() {
      if (this.items.length == 0) {
        this.ShowToast(
          '',
          'Favor seleccionar al menos una solicitud para Procesar Pago.',
          'error'
        );
        return;
      }

      if (this.purchaseOrderNumber.length == 0) {
        this.ShowToast(
          '',
          'Favor seleccionar al menos una cifra para Procesar Pago.',
          'error'
        );
        return;
      }

      const total = this.purchaseOrderNumber.reduce((accumulator, object) => {
        return accumulator + object.amount;
      }, 0);

      if (this.totalAmount != total) {
        this.ShowToast(
          '',
          'El monto total de las cifras debe ser igual que el monto total a pagar.',
          'error'
        );
        return;
      }

      await _processBulkPayment({
        purchaseOrderNumberList: this.purchaseOrderNumber,
        disbursementRequestList: this.items.map((a) => a.requestId),
        academicYearId: this.academicYearId,
        month: this.month,
        year: this.year,
      }).then((response) => {
        if (!response.data.isValid) {
          this.ShowToast('', response.data.message, 'error');
          return;
        }

        this.ShowToast(
          'Proceso Exitoso',
          'El pago fue procesado exitosamente.',
          'success'
        );
        this.$emit('saved');
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.my-4-custom {
  margin-bottom: 1.4rem !important;
  margin-top: 1.4rem !important;
}
.fs-22 {
  font-size: 22px !important;
}
.fs-40 {
  font-size: 40px !important;
}
.text-gray-7 {
  color: map-get($colors, 'gray-7');
}

::v-deep .custom-input__extended {
  .input-group {
    .input-group-text {
      background: map-get($colors, 'green');
      color: map-get($colors, 'white');
    }
  }
}
</style>
